import styled from "styled-components";

export const BaseButton = styled.button(({ width, backgroundcolor, color, border }) => {
  return {
    //styles for button should begin below this line.
    textAlign: "center",
    backgroundColor: backgroundcolor || "var(--color-primary)",
    border: "none",
    color: color || "white",
    borderRadius: ".5rem",
    width: width || "-webkit-fill-available",
    padding: "calc(var(--cardPadding)/3.35) calc(var(--cardPadding)/2)",
    fontSize: "1rem",
    cursor: "pointer",
    "@media screen and (max-width: 425px)": {
      width: "-webkit-fill-available",
    },
  };
});
